// extracted by mini-css-extract-plugin
export default {"root":"CircularDesignMetrics_root__tWmph"};